import React from 'react';
import classes from './NumberCell.module.css';

const NumberCell = ({ value }) => {

    const formatted = Number(value)?.toLocaleString('he-IL');

    return (
        <div className={classes.numberCell}>
            {formatted}
        </div>
    );
};

export default NumberCell;
